import React from "react";
import { Form } from "react-bootstrap";
import { useHelp } from "../../../components/Help/HelpContext";
import SubmitErrorReporter from "./SubmitErrorReporter";
import SummaryPanel from "./SummaryPanel";
import CustomerStep from "./steps/CustomerStep";
import ServiceStep from "./steps/ServiceStep";
import ScheduleStep from "./steps/ScheduleStep";
import ReviewStep from "./steps/ReviewStep";

// While the guided tour runs every step is shown, so each tour target exists on screen.
function useTourRunning() {
  try {
    return useHelp().isTourRunning;
  } catch (e) {
    return false; // no provider (tests): no tour
  }
}

// The form body: every step's content plus the summary and the Back / Next / Confirm bar.
// All four steps stay mounted and the inactive ones are hidden (not unmounted), so nothing a
// step keeps in its own state - the chosen vehicle, a staged part, a half-typed search - is
// lost when the user goes back and forth.
function BookingStepperForm({ b, formik }) {
  const { stepKey, stepIndex, steps, isEditing, goNext, goBack, onSubmitErrorField, requestCancel, checkoutSubmitting } = b;
  const tourRunning = useTourRunning();
  const isLast = stepIndex === steps.length - 1;
  const busy = formik.isSubmitting || checkoutSubmitting;

  // Enter moves on; only the last step (or the Update button) saves.
  const onSubmit = (e) => {
    e.preventDefault();
    if (isLast) formik.submitForm();
    else goNext();
  };

  const pane = (key, node) => (
    <div className="bstep-pane" hidden={!tourRunning && stepKey !== key} data-step={key}>
      {node}
    </div>
  );

  return (
    <Form noValidate onSubmit={onSubmit}>
      <SubmitErrorReporter onErrorField={onSubmitErrorField} />
      <div className="bstep-layout">
        <div className="bstep-main">
          {pane("customer", <CustomerStep b={b} formik={formik} />)}
          {pane("service", <ServiceStep b={b} formik={formik} />)}
          {pane("schedule", <ScheduleStep b={b} formik={formik} />)}
          {pane("review", <ReviewStep b={b} formik={formik} />)}

          <div className="bstep-footer">
            <button type="button" className="btn btn-outline-secondary px-4" onClick={() => requestCancel(formik.dirty)} disabled={busy}>
              Cancel
            </button>
            <div className="bstep-footer-right">
              {stepIndex > 0 && (
                <button type="button" className="btn btn-outline-secondary px-4" onClick={goBack} disabled={busy}>
                  Back
                </button>
              )}
              {!isLast && (
                <button type="button" className={`btn px-4 ${isEditing ? "btn-outline-danger" : "btn-danger"}`} onClick={goNext} disabled={busy}>
                  Next
                </button>
              )}
              {(isLast || isEditing) && (
                <button type="button" className="btn btn-danger px-4" onClick={() => formik.submitForm()} disabled={busy}>
                  {busy ? "Please wait…" : isEditing ? "Update" : "Confirm Booking"}
                </button>
              )}
            </div>
          </div>
        </div>

        <aside className="bstep-aside">
          <SummaryPanel b={b} formik={formik} />
        </aside>
      </div>
    </Form>
  );
}

export default BookingStepperForm;
